import { render, staticRenderFns } from "./LocationPoint.vue?vue&type=template&id=4a777300&scoped=true&"
import script from "./LocationPoint.vue?vue&type=script&lang=js&"
export * from "./LocationPoint.vue?vue&type=script&lang=js&"
import style0 from "./LocationPoint.vue?vue&type=style&index=0&id=4a777300&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a777300",
  null
  
)

export default component.exports